module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateChannelTemplate[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelTemplateId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.templateId),
      expression: "templateId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Identifant de gabarit / Template ID"
    },
    domProps: {
      "value": (_vm.templateId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templateId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelChannelName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelName),
      expression: "channelName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Identifant d'appareil / Device identifier"
    },
    domProps: {
      "value": (_vm.channelName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.channelName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelChannelType[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelType),
      expression: "channelType"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type d'appareil / Device type"
    },
    domProps: {
      "value": (_vm.channelType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.channelType = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelChannelDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelDescription),
      expression: "channelDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.channelDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.channelDescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelIconFile[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelIconFile),
      expression: "channelIconFile"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.channelIconFile = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.pictureList), function(picture) {
    return _c('option', {
      domProps: {
        "value": picture.fileName
      }
    }, [_vm._v(_vm._s(picture.pictureReferenceName))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "50px",
      "src": _vm._f("s3Image")(("organization_img/" + _vm.channelIconFile))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelSignalSet[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signalSetIndex),
      expression: "signalSetIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signalSetIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetListIndicatorsAndPanes()
      }]
    }
  }, _vm._l((_vm.signalsSetTemplates), function(signalSet, indexSignalSet) {
    return _c('option', {
      domProps: {
        "value": indexSignalSet
      }
    }, [_vm._v(_vm._s(signalSet.signalSetId))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelFrontEndComponent[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frontendChannelComponent),
      expression: "frontendChannelComponent"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.frontendChannelComponent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "MultiPanes_V1P00"
    }
  }, [_vm._v("Multi Panes version 1")])])])])]), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleListIndicator[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.componentListIndicators), function(componentListIndicator, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('h5', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.labelIndicator[_vm.actualLanguage]) + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelListIndicatorVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.varName),
        expression: "componentListIndicator.varName"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "varName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.selectListIndicatorSignal(index)
        }]
      }
    }, _vm._l((_vm.signalsSetTemplates[_vm.signalSetIndex].deviceSignals), function(signal, indexSignal) {
      return _c('option', {
        domProps: {
          "value": signal.signalName
        }
      }, [_vm._v(_vm._s(signal.signalName))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelListIndicatorLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.label.FR),
        expression: "componentListIndicator.label.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (componentListIndicator.label.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentListIndicator.label, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelListIndicatorLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.label.EN),
        expression: "componentListIndicator.label.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (componentListIndicator.label.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentListIndicator.label, "EN", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelListIndicatorAgregation[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.agregation),
        expression: "componentListIndicator.agregation"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "agregation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "Sum"
      }
    }, [_vm._v("Somme/Sum")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Min"
      }
    }, [_vm._v("Minimum")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Max"
      }
    }, [_vm._v("Maximum")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Avr"
      }
    }, [_vm._v("Moyenne/Average")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Last"
      }
    }, [_vm._v("Dernière mesure/Last measure")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 push"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-2"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelTileSize[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.width),
        expression: "componentListIndicator.width"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "width", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "Small"
      }
    }, [_vm._v("Small")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Medium"
      }
    }, [_vm._v("Medium")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Large"
      }
    }, [_vm._v("Large")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Full"
      }
    }, [_vm._v("Full")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-2"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v("Decimal")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.decimal),
        expression: "componentListIndicator.decimal"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "decimal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("0")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("1")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("2")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("3")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "4"
      }
    }, [_vm._v("4")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "5"
      }
    }, [_vm._v("5")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "6"
      }
    }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelTileLabelIcon[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.favIcon),
        expression: "componentListIndicator.favIcon"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "favIcon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.faFavIconList), function(icon) {
      return _c('option', {
        domProps: {
          "value": icon
        }
      }, [_vm._v(_vm._s(icon))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelTileLabelIcon2[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.favIcon),
        expression: "componentListIndicator.favIcon"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Variable"
      },
      domProps: {
        "value": (componentListIndicator.favIcon)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentListIndicator, "favIcon", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-2"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelIndicatorTestValue[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.value),
        expression: "componentListIndicator.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Variable"
      },
      domProps: {
        "value": (componentListIndicator.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentListIndicator, "value", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('h5', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.labelIndicatorColorCondition[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((componentListIndicator.colorConditions), function(condition, index2) {
      return _c('div', {
        staticClass: "col-xs-12"
      }, [(condition.customColorFlag == false) ? _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelTileColor[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (condition.colorBackground),
          expression: "condition.colorBackground"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(condition, "colorBackground", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "#46c37b"
        }
      }, [_vm._v("Vert std/Green std")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "#0000ff"
        }
      }, [_vm._v("Bleu/Blue")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "#00ff00"
        }
      }, [_vm._v("Vert/Green")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "#e1e100"
        }
      }, [_vm._v("Jaune/Yellow")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "#ff0000"
        }
      }, [_vm._v("Rouge/Red")])])]) : _vm._e(), _vm._v(" "), (condition.customColorFlag == false) ? _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.buttonSetCustomColor[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
        staticClass: "btn btn-sm btn-success",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.switchCustomColor(index, index2, true)
          }
        }
      }, [_vm._m(0, true)])])]) : _vm._e(), _vm._v(" "), (condition.customColorFlag) ? _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.buttonSetCustomColor[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model:value",
          value: (_vm.componentListIndicators[index].colorConditions[index2].colorBackground),
          expression: "componentListIndicators[index].colorConditions[index2].colorBackground",
          arg: "value"
        }],
        attrs: {
          "type": "color",
          "id": "head",
          "name": "head"
        },
        domProps: {
          "value": (_vm.componentListIndicators[index].colorConditions[index2].colorBackground)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.componentListIndicators[index].colorConditions[index2], "colorBackground", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (condition.customColorFlag) ? _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.buttonSetCustomColor[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
        staticClass: "btn btn-sm btn-success",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.switchCustomColor(index, index2, false)
          }
        }
      }, [_vm._m(1, true)])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-2"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelIndicatorMinValue[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (condition.minValue),
          expression: "condition.minValue"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Variable"
        },
        domProps: {
          "value": (condition.minValue)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(condition, "minValue", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-2"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelIndicatorMaxValue[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (condition.maxValue),
          expression: "condition.maxValue"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Variable"
        },
        domProps: {
          "value": (condition.maxValue)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(condition, "maxValue", $event.target.value)
          }
        }
      })])])
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-12 align-center"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-xs btn-default push-5-r push-10",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addConditionalColor(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonAddColorCondition[_vm.actualLanguage]))])])])]), _vm._v(" "), (componentListIndicator.colorConditions.length > 1) ? _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-xs btn-default push-5-r push-10",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteConditionalColor(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-minus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonDeleteColorCondition[_vm.actualLanguage]))])])])]) : _vm._e()])])], 2)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addListIndicator()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddListIndicator[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.componentListIndicators.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteListIndicator()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteListIndicator[_vm.actualLanguage]))])])])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered block-themed block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.labelListIndicatorPreview[_vm.actualLanguage]))]), _vm._v(" "), _c('api-device-list-indicator-v1p00', {
    attrs: {
      "componentListIndicators": _vm.componentListIndicators
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitlePanes[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.componentDetailPanes), function(componentDetailPane, index) {
    return _c('div', [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-12 col-lg-12"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textTitlePanes[_vm.actualLanguage]) + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelPaneButtonLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentDetailPane.buttonLabel.FR),
        expression: "componentDetailPane.buttonLabel.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Étiquette/Label"
      },
      domProps: {
        "value": (componentDetailPane.buttonLabel.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentDetailPane.buttonLabel, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelPaneButtonLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentDetailPane.buttonLabel.EN),
        expression: "componentDetailPane.buttonLabel.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Étiquette/Label"
      },
      domProps: {
        "value": (componentDetailPane.buttonLabel.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentDetailPane.buttonLabel, "EN", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelPaneTitleFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentDetailPane.title.FR),
        expression: "componentDetailPane.title.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Titre/Title"
      },
      domProps: {
        "value": (componentDetailPane.title.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentDetailPane.title, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6 push"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelPaneTitleEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentDetailPane.title.EN),
        expression: "componentDetailPane.title.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Titre/Title"
      },
      domProps: {
        "value": (componentDetailPane.title.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentDetailPane.title, "EN", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-12 col-lg-12"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textTileSection[_vm.actualLanguage]) + ":" + _vm._s(index + 1))])]), _vm._v(" "), _vm._l((componentDetailPane.tilesIndicator), function(tile, index2) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "block block-bordered block-themed block-content"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('h5', {
        staticClass: "font-w300 push-10"
      }, [_vm._v(_vm._s(_vm.textTile[_vm.actualLanguage]) + ":" + _vm._s(index2 + 1))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelTileVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.varName),
          expression: "tile.varName"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "varName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.selectTileSignal(index, index2)
          }]
        }
      }, _vm._l((_vm.signalsSetTemplates[_vm.signalSetIndex].deviceSignals), function(signal, indexSignal) {
        return _c('option', {
          domProps: {
            "value": signal.signalName
          }
        }, [_vm._v(_vm._s(signal.signalName))])
      }), 0)]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.label.FR),
          expression: "tile.label.FR"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Étiquette/Label"
        },
        domProps: {
          "value": (tile.label.FR)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tile.label, "FR", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.label.EN),
          expression: "tile.label.EN"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Étiquette/Label"
        },
        domProps: {
          "value": (tile.label.EN)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tile.label, "EN", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelTileAgregation[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.agregation),
          expression: "tile.agregation"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "agregation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "Sum"
        }
      }, [_vm._v("Somme/Sum")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Min"
        }
      }, [_vm._v("Minimum")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Max"
        }
      }, [_vm._v("Maximum")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Avr"
        }
      }, [_vm._v("Moyenne/Average")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6"
      }, [_c('div', {
        staticClass: "col-sm-12"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelTileColor[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.colorBackground),
          expression: "tile.colorBackground"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "colorBackground", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "bg-primary"
        }
      }, [_vm._v("Bleu/Blue")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-success"
        }
      }, [_vm._v("Vert/Green")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-danger"
        }
      }, [_vm._v("Rouge/Red")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-primary-dark"
        }
      }, [_vm._v("Foncé/Dark")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-modern"
        }
      }, [_vm._v("Bleu pale/Light Blue")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-amethyst"
        }
      }, [_vm._v("Violet/Purple")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-city"
        }
      }, [_vm._v("Rouge Pale/Light Red")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileValueSufix[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.valueSufix),
          expression: "tile.valueSufix"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "$, %, C ..."
        },
        domProps: {
          "value": (tile.valueSufix)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tile, "valueSufix", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v("Decimal")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.decimal),
          expression: "tile.decimal"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "decimal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "0"
        }
      }, [_vm._v("0")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "1"
        }
      }, [_vm._v("1")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "2"
        }
      }, [_vm._v("2")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "3"
        }
      }, [_vm._v("3")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "4"
        }
      }, [_vm._v("4")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "5"
        }
      }, [_vm._v("5")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "6"
        }
      }, [_vm._v("6")])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6 push"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileLabelIcon[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.favIcon),
          expression: "tile.favIcon"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "favIcon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.faFavIconList), function(icon) {
        return _c('option', {
          domProps: {
            "value": icon
          }
        }, [_vm._v(_vm._s(icon))])
      }), 0), _vm._v(" "), _c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileLabelIcon2[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.favIcon),
          expression: "tile.favIcon"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Variable"
        },
        domProps: {
          "value": (tile.favIcon)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tile, "favIcon", $event.target.value)
          }
        }
      })])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-sm btn-success",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addTile(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonAddTile[_vm.actualLanguage]))])])])]), _vm._v(" "), (componentDetailPane.tilesIndicator.length > 0) ? _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLastTile(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-minus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonDeleteLastTile[_vm.actualLanguage]))])])])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-12 col-lg-12"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textGraphsSection[_vm.actualLanguage]) + ":" + _vm._s(index + 1))])]), _vm._v(" "), _vm._l((componentDetailPane.graphs), function(graph, index3) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "block block-bordered block-themed block-content"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('h5', {
        staticClass: "font-w300 push-10"
      }, [_vm._v(_vm._s(_vm.textGraph[_vm.actualLanguage]) + ":" + _vm._s(index3 + 1))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12 col-lg-12 push"
      }, [_c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelGraphTitleFR[_vm.actualLanguage]) + ":" + _vm._s(index3 + 1))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (graph.title.FR),
          expression: "graph.title.FR"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Étiquette/Label"
        },
        domProps: {
          "value": (graph.title.FR)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(graph.title, "FR", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelGraphTitleEN[_vm.actualLanguage]) + ":" + _vm._s(index3 + 1))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (graph.title.EN),
          expression: "graph.title.EN"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Étiquette/Label"
        },
        domProps: {
          "value": (graph.title.EN)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(graph.title, "EN", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (graph.type),
          expression: "graph.type"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(graph, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "LineSingle"
        }
      }, [_vm._v("Ligne simple / Line single")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "LineMultiple"
        }
      }, [_vm._v("Ligne multiples / Line multiple")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "BarSingle"
        }
      }, [_vm._v("Barre simple / Bar single")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "BarMultiple"
        }
      }, [_vm._v("Barre multiples / Bar multiple")])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12 col-lg-12"
      }, [_c('h5', {
        staticClass: "font-w300 push-10"
      }, [_vm._v(_vm._s(_vm.textGraphTraceSection[_vm.actualLanguage]) + ":" + _vm._s(index3 + 1))])]), _vm._v(" "), _vm._l((graph.traces), function(trace, index4) {
        return _c('div', {
          staticClass: "col-xs-12 col-md-12"
        }, [_c('div', {
          staticClass: "col-sm-12 col-md-12 col-lg-12"
        }, [_c('h5', {
          staticClass: "font-w300 push-10"
        }, [_vm._v("Trace:" + _vm._s(index4 + 1))])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "example-multiple-select"
          }
        }, [_vm._v(_vm._s(_vm.labelTileVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (trace.yVarName),
            expression: "trace.yVarName"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "1"
          },
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(trace, "yVarName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }, function($event) {
              return _vm.selectGraphTraceSignal(index, index3, index4)
            }]
          }
        }, _vm._l((_vm.signalsSetTemplates[_vm.signalSetIndex].deviceSignals), function(signal, indexSignal) {
          return _c('option', {
            domProps: {
              "value": signal.signalName
            }
          }, [_vm._v(_vm._s(signal.signalName))])
        }), 0)]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "register4-firstname"
          }
        }, [_vm._v(_vm._s(_vm.labelGraphTraceFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (trace.label.FR),
            expression: "trace.label.FR"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "placeholder": "Étiquette/Label"
          },
          domProps: {
            "value": (trace.label.FR)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(trace.label, "FR", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "register4-firstname"
          }
        }, [_vm._v(_vm._s(_vm.labelGraphTraceEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (trace.label.EN),
            expression: "trace.label.EN"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "placeholder": "Étiquette/Label"
          },
          domProps: {
            "value": (trace.label.EN)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(trace.label, "EN", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3 push"
        }, [_c('label', {
          attrs: {
            "for": "example-multiple-select"
          }
        }, [_vm._v(_vm._s(_vm.labelHrDayTraces[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (trace.hourDayTraces),
            expression: "trace.hourDayTraces"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "4",
            "multiple": ""
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(trace, "hourDayTraces", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, [_c('option', {
          attrs: {
            "value": "Min"
          }
        }, [_vm._v("Min")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Max"
          }
        }, [_vm._v("Max")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Avr"
          }
        }, [_vm._v("Moyenne/Average")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Sum"
          }
        }, [_vm._v("Sum")])])])])
      }), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-sm btn-success",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.addGraphTrace(index, index3)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-plus fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.buttonAddGraphTrace[_vm.actualLanguage]))])])])]), _vm._v(" "), (componentDetailPane.graphs.length > 0) ? _c('div', {
        staticClass: "col-sm-12 col-md-6"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-sm btn-danger",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteLastGraphTrace(index, index3)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-minus fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.buttonDeleteLastGraphTrace[_vm.actualLanguage]))])])])]) : _vm._e()], 2)])])
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-sm btn-success",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addGraph(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonAddGraph[_vm.actualLanguage]))])])])]), _vm._v(" "), (componentDetailPane.graphs.length > 0) ? _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLastGraph(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-minus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonDeleteLastGraph[_vm.actualLanguage]))])])])]) : _vm._e()], 2)])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-md btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addPane()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddPane[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.componentDetailPanes.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-md btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteLastPane()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteLastPane[_vm.actualLanguage]))])])])]) : _vm._e()])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered block-themed block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.labePanePreview[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.componentDetailPanes.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12 align-center"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshPane()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonPaneRefresh[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayPreview) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('api-device-panes-v1p00', {
    attrs: {
      "panes": _vm.componentDetailPanes
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.componentDetailPanes.length > 0 & _vm.componentListIndicators.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 push"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectApiKey[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedApiKey),
      expression: "selectedApiKey"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedApiKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.overlayParameters.organizationApiKeys), function(key) {
    return _c('option', {
      domProps: {
        "value": key.key
      }
    }, [_vm._v(_vm._s(key.referenceName) + " : " + _vm._s(key.key))])
  }), 0)]), _vm._v(" "), (_vm.selectedApiKey.length > 0) ? _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveChannelTemplate()
      }
    }
  }, [(_vm.templateIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-pencil fa-1x push-5-r "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31211cb7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/OrganizationApiChannelTemplateAddForm.vue
// module id = 1519
// module chunks = 4